import { apiClient } from "./client"

// prefixes: array of strings, e.g. ["Z2604","Z2704"]
export async function fetchObjednavky({ prefixes = ["Z2604"], limit = 200 } = {}) {
  const qs = new URLSearchParams()
  qs.set("limit", String(limit))

  if (Array.isArray(prefixes) && prefixes.length > 0) {
    qs.set("prefixes", prefixes.join(","))
  } else {
    qs.set("prefix", "Z2604")
  }

  return apiClient.get(`/objednavky?${qs.toString()}`)
}

export async function deleteObjednavka(idobj) {
  if (!idobj) {
    throw new Error("Chybí ID objednávky.")
  }
  const qs = new URLSearchParams()
  qs.set("idobj", String(idobj))
  return apiClient.del(`/mrp/smazatobjednavka?${qs.toString()}`)
}

export async function fetchObjednavka(idobj) {
  if (!idobj) {
    throw new Error("Chybí ID objednávky.")
  }
  const qs = new URLSearchParams()
  qs.set("idobj", String(idobj))
  return apiClient.get(`/mrp/nactiobjednavka?${qs.toString()}`)
}

export async function createSkladovyPohyb({ idobj, druhpohybu }) {
  if (!idobj) {
    throw new Error("Chybí ID objednávky.")
  }
  if (![1, 2].includes(Number(druhpohybu))) {
    throw new Error("Neplatný druh pohybu.")
  }
  return apiClient.post('/mrp/novypohyb', {
    idobj: Number(idobj),
    druhpohybu: Number(druhpohybu),
  })
}

export async function fetchProdejkaPohyb(cisloObjed) {
  const cislo = String(cisloObjed ?? '').trim()
  if (!cislo) {
    throw new Error("Chybí číslo objednávky.")
  }
  const qs = new URLSearchParams()
  qs.set('cisloobjed', cislo)
  return apiClient.get(`/mrp/pohyb-prodejka?${qs.toString()}`)
}

